function Spinner() {
    return (
        <div className="custom-loader"></div>
    )
}
export default Spinner;